<header class="header">
  <h2>{{ labelService.getLabel("note") }}</h2>
  <div class="header-buttons">
    @if (isMobile) {
      <app-button
        [size]="'icon-small'"
        [icon]="'swap_horiz'"
        color="light-green"
        (click)="switchSectionMobile()"
      ></app-button>
    }
    <app-button
      [icon]="'add'"
      [size]="'icon-small'"
      (click)="toggleAddNotePanel()"
    ></app-button>
  </div>
</header>
@if (notes.length > 0) {
  <div class="note-table">
    @for (note of notes; track note) {
      <div class="note-row">
        <span (click)="toggleUpdateNotePanel(note)">
          {{ note.description }}</span
        >
        <mat-icon
          style="font-size: 20px; cursor: pointer"
          (click)="deleteNote(note)"
          >delete</mat-icon
        >
      </div>
    }
  </div>
}
@if (notes.length === 0) {
  <div class="no-notes">
    <img src="assets/imgs/undraw/undraw_void.svg" alt="Nessuna Nota" />
    <span>Nessuna nota disponibile</span>
  </div>
}

<!-- add note panel -->
@if (showAddNotePanel) {
  <app-panel-with-text-area
    [title]="'Nuova Nota'"
    (close)="toggleAddNotePanel()"
    (confirm)="createNewNote($event)"
  ></app-panel-with-text-area>
}

<!-- update note panel -->
@if (showUpdateNotePanel) {
  <app-panel-with-text-area
    [title]="'Vuoi modificare la nota?'"
    [text]="selectedNote.description"
    (close)="toggleUpdateNotePanel()"
    (confirm)="updateNote($event)"
  ></app-panel-with-text-area>
}
